import * as Yup from "yup";

export const brigadeFormSchema = Yup.object().shape({
  name: Yup.string()
    .required("Назва бригади обов'язкова")
    .max(250, "Назва бригади повинна містити не більше 250 символів"),
  image: Yup.string().required("Емблема бригади обов'язкова"),
});
